import React from "react";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";

function TableHeader({ tableHeaderList }) {
  const { language, translations } = useLanguage();
  const t = translations[language];
  return (
    <thead>
      <tr>
        {tableHeaderList.map((item, index) => (
          <th
            key={`head-{item.title}-${index}`}
            className={item.headerClassName}
            style={{ ...item.style }}
          >
            {item.isCheckbox
              ? item.handleCell(null, item, index)
              : t[item.title]}
          </th>
        ))}
      </tr>
    </thead>
  );
}

export default TableHeader;
